import React from "react";

import {
  formatDate,
  getStatusClass,
  getStatusLabel,
} from "../utils/publicOffer.utils";


const PublicOfferHeader = ({
  publicOffer,
}) => {

  const offer =
    publicOffer?.offer;

  const link =
    publicOffer?.publicOffer;


  if (!offer) {
    return null;
  }


  return (
    <header className="public-offer-header">

      <div className="public-offer-header-main">

        <div>
          <p className="public-offer-eyebrow">
            Offer Proposal
          </p>

          <h1>
            {offer.offerNumber}
          </h1>

          <p className="public-offer-date">
            Created{" "}
            {formatDate(
              offer.createdAt
            )}
          </p>
        </div>


        {link?.status && (
          <span
            className={`public-offer-status ${getStatusClass(
              link.status
            )}`}
          >
            {getStatusLabel(
              link.status
            )}
          </span>
        )}

      </div>


      {offer.validUntil && (
        <div className="public-offer-validity">

          <span>
            Valid until
          </span>

          <strong>
            {formatDate(
              offer.validUntil
            )}
          </strong>

        </div>
      )}

    </header>
  );
};


export default PublicOfferHeader;
